import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Step from 'book-calculator/components/Step';
import BasicsFieldset from 'book-calculator/containers/BasicsFieldset';

const BasicsStep = ({ step }) => (
    <Step
        step={step}
        title={<FormattedMessage id="steps.basics.heading" />}
        description={<FormattedMessage id="steps.basics.description" />}
    >
        <BasicsFieldset />
    </Step>
);

BasicsStep.propTypes = {
    step: PropTypes.number.isRequired,
};

export default BasicsStep;
